




















import { Event } from 'inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { EventDateHelper } from '../services/EventDateHelper';
import EventTimelineComponent from './EventTimeline.vue';

@Component({
  components: {
    EventTimeline: EventTimelineComponent,
  },
})
export default class EventInfoDatesComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  private showTimeline = false;

  get eventDate() {
    return EventDateHelper.getDate(this.event.info.date, true);
  }
}
